import { useEffect, useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";

/** Okno odrzucenia zdjęć MDCP — powód jest OBOWIĄZKOWY, bo to jedyna informacja, z jaką
 *  geodeta wraca w teren: „nie przeszło" bez wskazania, co jest nie tak, kosztuje drugi
 *  wyjazd. Ten sam formularz obsługuje odrzucenie jednego zdjęcia i całego materiału
 *  zamówienia — różni je tylko `count` w nagłówku. */
export function MdcpPhotoRejectModal({
  open,
  count,
  scope,
  pending,
  error,
  onClose,
  onConfirm,
}: {
  open: boolean;
  /** Ile zdjęć obejmie odrzucenie (0 = całe zamówienie, liczba nieznana z góry). */
  count: number;
  /** „one" — pojedyncze zdjęcie, „all" — cały materiał zamówienia. */
  scope: "one" | "all";
  pending: boolean;
  error: string | null;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}) {
  const [reason, setReason] = useState("");

  // Świeże okno = świeży powód: uzasadnienie poprzedniego odrzucenia nie może po cichu
  // pojechać razem z następnym zdjęciem.
  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const trimmed = reason.trim();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={scope === "all" ? "Odrzuć wszystkie zdjęcia" : "Odrzuć zdjęcie"}
      size="md"
    >
      <div className="space-y-3">
        <p className="text-sm text-[var(--color-text-secondary)]">
          {scope === "all"
            ? `Odrzucisz cały materiał zdjęciowy tego zamówienia${count > 0 ? ` (${count} zdj.)` : ""}. `
            : "Odrzucisz to zdjęcie. "}
          Geodeta zobaczy powód w swoim zamówieniu i będzie mógł wgrać nowe zdjęcia; punkt bez
          ani jednego przyjętego zdjęcia wraca do stanu „do wykonania".
        </p>
        <label className="block space-y-1">
          <span className="text-xs font-semibold">Powód odrzucenia</span>
          <textarea
            autoFocus
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="np. zdjęcie nieostre / zły kierunek — widać drogę zamiast słupa / punkt sfotografowany z innego miejsca"
            className="w-full border border-[var(--color-border)] bg-[var(--color-bg-surface)] px-2 py-1.5 text-sm"
          />
        </label>
        {error && <p className="text-[11px] font-mono text-[var(--color-primary)]">{error}</p>}
        <div className="flex justify-end gap-2 pt-1">
          <Button variant="secondary" onClick={onClose} disabled={pending}>
            Anuluj
          </Button>
          <Button
            variant="danger"
            loading={pending}
            disabled={pending || trimmed.length === 0}
            onClick={() => onConfirm(trimmed)}
          >
            Odrzuć
          </Button>
        </div>
      </div>
    </Modal>
  );
}
